import axios from "axios";
import { Message } from "element-ui";
import router from "../router";

const ins = axios.create();
ins.interceptors.response.use(
  function (res) {
    const { code, message, result } = res.data;
    if (code !== 200) {
      Message.error(message);
    }
    return result;
  },
  function (error) {
    const { code, message } = error.response.data;
    if (code && code === 401) {
      Message.error(message);
      const { pending, current } = router.history;
      router.replace({
        path: "/login",
        query: {
          returnUrl: pending ? pending.fullPath : current.fullPath,
        },
      });
    }
  }
);

ins.interceptors.request.use(function (config) {
  const token = localStorage.getItem("userInfo");
  if (token) {
    config.headers.authorization = token;
  }
  return config;
});

export default ins;
